(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zb-product-description"] && !Shopify.designMode) return;
  try {
    (()=>{
  if(customElements.get('zb-product-description'))return;
  const heading=node=>node.nodeType===1&&/^H[2-4]$/.test(node.tagName);
  const name=text=>text.toLowerCase().replace(/[’']/g,'').replace(/&/g,'and').replace(/[^a-z0-9]+/g,' ').trim();
  function identify(text){
    const key=name(text);
    if(/^(overview|product overview|introduction|about this (bracelet|piece|product))$/.test(key))return 'intro';
    if(/natural variation|material and natural|important note|important reminder/.test(key))return 'notice';
    if(/^(core features|features|product details|details|details and sizing|sizing|size guide|specifications|materials|material|fit and sizing)$/.test(key))return 'details';
    if(/how to wear|styling|how to pair/.test(key))return 'styling';
    if(/meaning|symbolism|what its for|perfect for|design and|energy/.test(key))return 'meaning';
    if(/care|maintenance/.test(key))return 'care';
    if(/faq|frequently asked|questions/.test(key))return 'faq';
    if(/shipping|delivery|returns/.test(key))return 'shipping';
    return null;
  }
  function critical(node){
    if(node.nodeType!==1||!['P','UL','OL','BLOCKQUOTE'].includes(node.tagName))return false;
    const text=node.textContent.toLowerCase();
    return /natural (stones? |stone colour |stone color |color |colour |variations? |differences? )/.test(text)&&/var|differ|unique/.test(text)||/keep (?:it )?(?:completely )?dry|do not expose.{0,20}water|no water contact|do not ingest|allerg|irritation|keep (?:it )?away from water|do not (?:immerse|soak|wear.*water)|must (?:stay|be kept) dry|cannot.*water|not waterproof|avoid (?:all )?water|bead diameter,? not wrist|not (?:the )?wrist circumference/.test(text);
  }
  class ProductDescription extends HTMLElement{
    connectedCallback(){
      if(this._ready||!this.children.length)return;
      this._ready=true;
      this.querySelectorAll('.zb-purchase-summary-source,.zb-fit-source').forEach(node=>node.remove());
      const storyTemplate=this.querySelector('[data-zb-story]');
      const storyTitle=storyTemplate?.querySelector('h2')?.textContent.trim();
      const storyLead=storyTemplate?.querySelector('p:not(.zb-description__eyebrow)')?.textContent.trim();
      storyTemplate?.remove();
      const optionTemplate=this.querySelector('template[data-zb-specs]');
      const optionRows=optionTemplate?[...optionTemplate.content.querySelectorAll('div')].map(cell=>({label:cell.querySelector('dt').textContent,value:cell.querySelector('dd').textContent})):[];
      optionTemplate?.remove();
      const source=Array.from(this.childNodes),parts=[];
      let current={key:'intro',label:'',nodes:[]};parts.push(current);
      const flatten=node=>{
        if(node.nodeType===1&&['DIV','SECTION','ARTICLE'].includes(node.tagName)&&node.querySelector('h2,h3,h4,details'))return Array.from(node.childNodes).flatMap(flatten);
        return [node];
      };
      source.flatMap(flatten).forEach(node=>{
        if(heading(node)){
          const label=node.textContent.trim(),key=identify(label);
          if(key==='intro'){current=parts[0];return;}
          if(!key&&parts.length===1&&!parts[0].nodes.some(n=>n.nodeType===1)){
            parts[0].nodes.push(node);current=parts[0];return;
          }
          current={key:key||'other',label,nodes:[]};parts.push(current);return;
        }
        if(node.nodeType===1&&node.tagName==='DETAILS'){
          const summary=node.querySelector(':scope>summary');
          if(summary){const label=summary.textContent.trim();parts.push({key:identify(label)||'other',label,nodes:Array.from(node.childNodes).filter(n=>n!==summary)});return;}
        }
        current.nodes.push(node);
      });
      const intro=document.createElement('div');intro.className='zb-description__intro';
      const notices=document.createElement('div');notices.className='zb-description__notices';
      const groups=new Map();
      const hasContent=nodes=>nodes.some(n=>n.nodeType===1||n.textContent.trim());
      for(const part of parts){
        if(part.key==='styling'||part.key==='shipping')continue;
        const ordinary=[];
        part.nodes.forEach(node=>{if(part.key==='notice'||critical(node))notices.append(node);else ordinary.push(node);});
        if(!hasContent(ordinary))continue;
        if(part.key==='intro'){intro.append(...ordinary);continue;}
        const groupKey=part.key==='other'?part.label:part.key;
        if(!groups.has(groupKey))groups.set(groupKey,{key:part.key,label:this.dataset[part.key]||part.label,parts:[]});
        groups.get(groupKey).parts.push({label:part.label,nodes:ordinary});
      }
      const fragment=document.createDocumentFragment();
      if(intro.textContent.trim()||intro.querySelector('img,video,iframe')){groups.set('design',{key:'design',label:this.dataset.design,parts:[{label:'',nodes:[intro]}]});}
      const noticeTarget=notices;
      if(notices.textContent.trim()){if(!groups.has('care'))groups.set('care',{key:'care',label:this.dataset.care,parts:[]});groups.get('care').parts.push({label:'',nodes:[notices]});}
      const rank={design:0,details:1,styling:2,meaning:3,care:4,faq:5,shipping:6,other:7};
      [...groups.values()].sort((a,b)=>rank[a.key]-rank[b.key]).forEach(group=>{
        const details=document.createElement('details');details.className='zb-description__section';details.open=false;
        const summary=document.createElement('summary');summary.textContent=group.label;
        const body=document.createElement('div');body.className='zb-description__body';
        group.parts.forEach(part=>{if(group.parts.length>1&&part.label){const title=document.createElement('h4');title.textContent=part.label;body.append(title);}body.append(...part.nodes);});
        details.append(summary,body);fragment.append(details);
      });

      noticeTarget.querySelectorAll('p,li').forEach(n=>{if(/keep.{0,15}dry|do not expose.{0,20}water|no water|not waterproof|do not ingest|allerg|irritation/i.test(n.textContent))n.classList.add('zb-description__safety');});

      this.replaceChildren(fragment);this.classList.add('is-enhanced');
    }
  }
  customElements.define('zb-product-description',ProductDescription);
})();
  } catch(e) { console.error(e); }
})();

})();
